// Styles
import '../sass/editor.scss';

import '../img/cover.jpeg';
